import React, { createContext, useContext, useMemo } from 'react';
import { isTelegramEnv } from '../utils/isTelegramEnv';

interface TelegramContextValue {
  isTelegram: boolean;
}

const TelegramContext = createContext<TelegramContextValue | null>(null);

export function TelegramProvider({ children }: { children: React.ReactNode }) {
  const value = useMemo(() => ({
    isTelegram: isTelegramEnv(),
  }), []);

  return (
    <TelegramContext.Provider value={value}>
      {children}
    </TelegramContext.Provider>
  );
}

export function useTelegram(): TelegramContextValue {
  const context = useContext(TelegramContext);
  if (!context) {
    throw new Error('useTelegram must be used within TelegramProvider');
  }
  return context;
}
